module.exports = __webpack_public_path__ + "img/img26.9620b014.png";